const MAX_HEIGHT = 480;
export {
  MAX_HEIGHT
};
//# sourceMappingURL=constants.js.map
